<script>
  import { Styles, Button } from 'sveltestrap';
  import { Textfield } from 'svelte-mui';
  import { api_url } from "./ConfigService.js";
  import { Router, Route, Link, navigate } from "svelte-routing";
  import Navbar from "./components/Navbar.svelte";
  import Footer from "./fotomaturak/Footer.svelte";
  //import Layout from "./fotomaturak/Layout.svelte";
  import Countdown from "./fotomaturak/Countdown.svelte";
  //import Boxes from "./fotomaturak/Boxes.svelte";
  import CardStats from "./fotomaturak/CardStats.svelte";
  //import VideoLevel from "./fotomaturak/VideoLevel.svelte";
  import Loading from "./components/Loading.svelte";

  import Home from "./pages/Home.svelte";
  import Order from "./pages/Order.svelte";
  import Cart from "./pages/Cart.svelte";
  import ShareDialog from "./components/shareDialog.svelte";
  import PhotoOrder from "./pages/PhotoOrder.svelte";
  import Imgupload from './components/Imgupload.svelte';

  export let share=false;
  export let orderno;
  export let ordernoInput;
  export let error;
  
  export let isOrder=false;
  function setOrder(value) { isOrder=value; return ""; }
  
  export let data = (async () => {
	 const resp = await fetch($api_url);
	 return await resp.json()
  })()

  export let url="";


  function openOrder() {
	navigate('/photos/'+orderno);
  }
  
  const handleOpenOrder = () => {
	openOrder();
  }

  function shareDialog() {
    share=true;
  }

</script>

<Styles />
<Router url="{url}">
<div>   
  <Navbar bind:data bind:isOrder bind:orderno />
  <main>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div
        class="absolute top-0 w-full h-full bg-no-repeat bg-full"
        style="background-image: url('/bg.png'); background-attachment: fixed; background-size: cover;"
      ></div>
      <div class="container masterBox mx-auto h-full">
        <div class="flex content-center items-center justify-center h-full">
          <div class="w-full px-4 px-mobile">
            <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div class="flex-auto px-4 lg:px-10 py-10">
              
			<Route path="cart/">
				<Cart />
			</Route>
			<Route path="photos/:id" let:params>
				<PhotoOrder orderno={params.id} />	
			</Route> 
			<Route path="photos/:id/:token" let:params>
				<PhotoOrder orderno={params.id} token={params.token} />	
			</Route> 
			<Route path="/">
				<Home bind:orderno />
			</Route>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {#if data}
          <Footer bind:data absolute="true" />
        {/if}
    </section>
  </main>
</div>
</Router>
<ShareDialog bind:data bind:open={share} />

<style>
h2 { font-size:20px; }
h3 { font-size:16px; font-weight:bold; margin-bottom:10px; }
.list-info { list-style-type:circle; }
.masterBox { min-width:80%; max-width:1715px; }
@media (max-width: 768px) {
	.px-mobile { padding-left:0px!important; padding-right:0px!important; }
}
</style>
